import { useEffect, useRef } from 'react';

import useRouter from 'js/lib/useRouter';

import type { AdminType } from '@coursera/event-pulse-types';
import { track } from '@coursera/event-pulse/sdk';

import type { ThirdPartyOrganization } from 'bundles/enterprise-admin/types';

/**
 * Hook that tracks 'view_admin_dashboard_page' on mount and on every route change.
 * Replaces the trackPageView() method from the legacy class component.
 */
export const useViewAdminDashboardPageTracker = (
  thirdPartyOrganization: ThirdPartyOrganization,
  adminRoleType?: string
): void => {
  const router = useRouter();
  const prevPathName = useRef<string>('');

  useEffect(() => {
    const currentPath = router.location.pathname;

    if (currentPath !== prevPathName.current) {
      track('view_admin_dashboard_page', {
        enterprise: {
          organizationSlug: thirdPartyOrganization.slug,
        },
        enterpriseAdminAccount: {
          adminType: (adminRoleType ? adminRoleType.toLowerCase().replace(/ /g, '_') : undefined) as AdminType,
        },
      });
      prevPathName.current = currentPath;
    }
  }, [router.location.pathname, thirdPartyOrganization.slug, adminRoleType]);
};
